@let options = analysisVersionOptions();
@let noOptions = options.length === 0;
@let isLoading = analysisStateService.versions.isLoading();

<pm-form-field label="ANALYSIS.ERROR_VERSION">
  <pm-form-input-select
    [disabled]="isLoading"
    [ngModel]="versionValue()"
    (ngModelChange)="versionSelectionChanged($event)"
    [data]="options"
    [sortByKey]="'createdAt'"
    [sortDirection]="'desc'"
    [placeholder]="
      noOptions
        ? ('ANALYSIS.NO_ERROR_VERSIONS_AVAILABLE' | translate)
        : undefined
    "
  />
</pm-form-field>
